export default __webpack_public_path__ + "a41dadb4d93703c1a67b5f9c18a7c8eb.svg";